//  @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import DeleteAccount from './DeleteAccount';

// Actions
import { deleteAccount } from 'store/reducers/user/personInfo/actions';
import { goTo } from 'store/reducers/navigation/actions';
import { generateTokenId } from 'store/reducers/tokenId/actions';

export default compose(
  injectIntl,
  connect(
    null,
    {
      deleteAccount,
      goTo,
      generateTokenId
    }
  )
)(DeleteAccount);



// WEBPACK FOOTER //
// ./src/components/pages/User/Profile/components/DeleteAccount/DeleteAccountContainer.js